import { Tooltip } from '@mui/material';
import React from 'react';

export interface TournamentActionsProps {
  onView: () => void;
  onPayments: () => void;
  onEdit: () => void;
}

const TournamentActions: React.FC<TournamentActionsProps> = ({  onView, onPayments, onEdit }) => {
  return (
    <div className="d-flex gap-2">
      <button type="button" className="btn btn-link p-0 text-primary" onClick={onView}>
        <Tooltip title="Visualizar Torneio" placement="top">
          <i className="bi bi-trophy" />
        </Tooltip>
      </button>
      <button type="button" className="btn btn-link p-0 text-info" onClick={onPayments}>
        <Tooltip title="Gerenciar Pagamentos" placement="top">
          <i className="bi bi-cash-stack" />
        </Tooltip>
      </button>
      <button type="button" className="btn btn-link p-0 text-warning" onClick={onEdit}>
        <Tooltip title="Editar Torneio" placement="top">
          <i className="bi bi-pencil" />
        </Tooltip>
      </button>
    </div>
  );
};

export default TournamentActions;
